import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const css = `
.lm-overlay {
  position: fixed; inset: 0;
  background: rgba(5,15,40,0.65);
  backdrop-filter: blur(8px);
  z-index: 99999;
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  animation: lmIn 0.2s ease;
  font-family: 'Nunito','Segoe UI',sans-serif;
}
@keyframes lmIn { from{opacity:0} to{opacity:1} }
.lm-box {
  background: #fff;
  border-radius: 20px;
  width: 100%; max-width: 420px;
  box-shadow: 0 32px 80px rgba(5,15,50,0.3);
  animation: lmUp 0.28s cubic-bezier(0.34,1.2,0.64,1);
  overflow: hidden;
  position: relative;
}
@keyframes lmUp {
  from{opacity:0;transform:translateY(20px) scale(0.97)}
  to{opacity:1;transform:translateY(0) scale(1)}
}
.lm-top {
  background: linear-gradient(135deg,#051530 0%,#1e3a8a 100%);
  padding: 32px 32px 28px;
  position: relative;
}
.lm-top-label {
  font-size: 11px; font-weight: 800; color: rgba(255,255,255,0.45);
  text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 8px;
}
.lm-top-title {
  font-size: 24px; font-weight: 900; color: #fff; margin: 0 0 5px;
}
.lm-top-sub {
  font-size: 13px; color: rgba(255,255,255,0.55); margin: 0;
}
.lm-x {
  position: absolute; top: 14px; right: 14px;
  width: 30px; height: 30px; border-radius: 50%;
  border: 1.5px solid rgba(255,255,255,0.18);
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.8); font-size: 13px;
  cursor: pointer; display: flex; align-items: center; justify-content: center;
}
.lm-x:hover { background: rgba(255,255,255,0.16); }
.lm-body { padding: 28px 32px 32px; }
.lm-f { display: flex; flex-direction: column; gap: 15px; }
.lm-lbl { font-size: 11px; font-weight: 800; color: #64748b; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 5px; display: block; }
.lm-inp {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  padding: 11px 13px; gap: 9px; background: #f8fafc;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.lm-inp:focus-within {
  border-color: #2563eb; background: #fff;
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
}
.lm-inp input {
  border: none; outline: none; flex: 1;
  font-size: 14px; color: #0f172a;
  font-family: 'Nunito','Segoe UI',sans-serif; background: transparent;
}
.lm-inp svg { color: #94a3b8; flex-shrink: 0; }
.lm-eye { background: transparent; border: none; cursor: pointer; color: #94a3b8; padding: 0; display: flex; }
.lm-err {
  background: #fff5f5; border: 1px solid #fecaca;
  border-radius: 9px; padding: 9px 13px;
  font-size: 12.5px; color: #dc2626;
}
.lm-submit {
  height: 48px;
  background: linear-gradient(135deg,#2563eb,#1e3a8a);
  color: #fff; border: none; border-radius: 10px;
  font-size: 15px; font-weight: 800;
  font-family: 'Nunito','Segoe UI',sans-serif;
  cursor: pointer; letter-spacing: 0.03em;
  transition: opacity 0.15s, transform 0.15s;
}
.lm-submit:hover { opacity: 0.9; transform: translateY(-1px); }
.lm-submit:disabled { opacity: 0.65; cursor: not-allowed; transform: none; }
.lm-div-row { display: flex; align-items: center; gap: 10px; }
.lm-div-line { flex: 1; height: 1px; background: #e2e8f0; }
.lm-div-txt { font-size: 12px; color: #94a3b8; white-space: nowrap; }
.lm-new-btn {
  height: 44px; background: #f8fafc;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  font-size: 13.5px; font-weight: 700; color: #0d2e6e;
  cursor: pointer; font-family: 'Nunito','Segoe UI',sans-serif;
  transition: background 0.15s, border-color 0.15s;
}
.lm-new-btn:hover { background: #eff6ff; border-color: #2563eb; color: #1d4ed8; }
`;

const MailSvg = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const LockSvg = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
const EyeSvg = ({o}) => o
  ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
  : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;

export default function LoginModal({ onClose }) {
  const navigate = useNavigate();
  const [em, setEm]     = useState('');
  const [pw, setPw]     = useState('');
  const [sp, setSp]     = useState(false);
  const [err, setErr]   = useState('');
  const [ld, setLd]     = useState(false);

  useEffect(() => {
    if (!document.getElementById('lm-css')) {
      const t = document.createElement('style');
      t.id = 'lm-css'; t.textContent = css;
      document.head.appendChild(t);
    }
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const go = async (e) => {
    if (e) e.preventDefault();
    setErr('');
    if (!em || !pw) { setErr('Please fill in all fields.'); return; }
    setLd(true);
    try {
      const r = await fetch('http://localhost:5000/api/users/login', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email:em.trim(), password:pw }),
      });
      const d = await r.json();
      if (!r.ok) { setErr(d.message||'Login failed.'); return; }
      localStorage.setItem('ibots_user_token', d.token);
      localStorage.setItem('ibots_user', JSON.stringify(d.user));
      window.dispatchEvent(new Event('ibots_user_updated'));
      onClose();
      navigate('/my-account');
    } catch { setErr('Cannot reach server. Make sure backend is running.'); }
    finally { setLd(false); }
  };

  return (
    <div className="lm-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="lm-box">
        <div className="lm-top">
          <div className="lm-top-label">iBots Portal</div>
          <h2 className="lm-top-title">Sign in to continue</h2>
          <p className="lm-top-sub">Access your courses, registrations and certificates.</p>
          <button className="lm-x" onClick={onClose}>✕</button>
        </div>
        <div className="lm-body">
          <form className="lm-f" onSubmit={go}>
            <div>
              <label className="lm-lbl">Email Address</label>
              <div className="lm-inp"><MailSvg /><input type="email" placeholder="you@email.com" value={em} onChange={e=>setEm(e.target.value)} autoComplete="email" /></div>
            </div>
            <div>
              <label className="lm-lbl">Password</label>
              <div className="lm-inp"><LockSvg /><input type={sp?'text':'password'} placeholder="••••••••" value={pw} onChange={e=>setPw(e.target.value)} autoComplete="current-password" /><button type="button" className="lm-eye" onClick={()=>setSp(s=>!s)}><EyeSvg o={sp}/></button></div>
            </div>
            {err && <div className="lm-err">{err}</div>}
            <button type="submit" className="lm-submit" disabled={ld}>{ld?'Signing in...':'Sign In'}</button>
            <div className="lm-div-row"><div className="lm-div-line"/><span className="lm-div-txt">New to iBots?</span><div className="lm-div-line"/></div>
            <button type="button" className="lm-new-btn" onClick={()=>{onClose();navigate('/register');}}>Create a free account</button>
          </form>
        </div>
      </div>
    </div>
  );
}
